<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <!-- 预警报警看板 -->
  <div class="mainWarp">
    <div v-show="show" class="alarm-panel">
      <div class="panel-header">
        <div class="header-left">
          <img src="~@/assets/partition/alarmicon2.svg" alt="" class="warning-icon" />
          <span class="header-title">预警报警</span>
        </div>
        <img src="~@/assets/partition/hide.svg" alt="" class="hide-btn" @click="show = false" />
      </div>
      <div class="dataWarp" id="dataWarp" @scroll.prevent @mouseenter="pauseScroll" @mouseleave="resumeScroll">
        <div v-if="!dataList.length" class="empty-text">暂无</div>
        <template v-else>
          <div class="ulDiv" id="ulDiv" @scroll.prevent>
          <div class="dataItem" @scroll.prevent v-for="item in dataList" :key="'a-' + item.id">
            <a-popover placement="right" trigger="hover" overlayClassName="alarm-detail-popover-wrapper">
              <template slot="content">
                <div class="alarm-detail-popover">
                  <div class="detail-header">
                    <span class="zone-name">{{ item.msgAddress || item.alarmName }}</span>
                    <span class="alarm-tag" :class="getAlarmTagClass(item)">{{ item.alarmDescription }}</span>
                  </div>
                  <div class="detail-body">
                    <div class="detail-row">
                      <span class="detail-label">开始报警时间:</span>
                      <span class="detail-value">{{ getStartAlarmTime(item) }}</span>
                    </div>
                    <div class="detail-row detail-row-wrap" v-if="item.alarmSource === 'dataInterruption'">
                      <span class="detail-label">报警说明:</span>
                      <span class="detail-value">{{ item.description != null && item.description !== '' ? item.description : '-' }}</span>
                    </div>
                
                    <template v-if="item.alarmSource === 'manual'">
                      <div class="detail-row">
                        <span class="detail-label">夜间总流量:</span>
                        <span class="detail-value">{{ item.refValue != null ? item.refValue : '-' }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">当前报警值:</span>
                        <span class="detail-value">{{ item.prewarningValue != null ? item.prewarningValue : '-' }}</span>
                      </div>
                    </template>
                    <template v-if="item.alarmSource === 'dualTrack'">
                      <div class="detail-row">
                        <span class="detail-label">最后报警时间:</span>
                        <span class="detail-value">{{ item.updateTime || '-' }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">夜间总流量:</span>
                        <span class="detail-value">{{ item.nightAllWaterNum != null ? item.nightAllWaterNum : (item.nightWaterNum != null ? item.nightWaterNum : '-') }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">夜间流量平均值:</span>
                        <span class="detail-value">{{ item.nightWaterNum != null ? item.nightWaterNum : (item.nightAvg != null ? item.nightAvg : '-') }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">正常范围:</span>
                        <span class="detail-value">{{ getNormalRange(item) }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">基线:</span>
                        <span class="detail-value">{{ item.baseLine != null ? item.baseLine : (item.baseline != null ? item.baseline : '-') }}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <div
                class="title"
                :class="getAlarmClass(item)"
                @click="Rowclicklu(item)"
              >
                <span class="alarmName">{{ item.alarmName }}</span>
                <span class="alarmTime">{{ item.alarmTime }}</span>
                <span class="alarmDesc">{{ item.alarmDescription }}</span>
              </div>
            </a-popover>
          </div>
        </div>
        <div id="ulDiv2">
          <div class="dataItem" @scroll.prevent v-for="item in dataList" :key="'b-' + item.id">
            <a-popover placement="right" trigger="hover" overlayClassName="alarm-detail-popover-wrapper">
              <template slot="content">
                <div class="alarm-detail-popover">
                  <div class="detail-header">
                    <span class="zone-name">{{ item.msgAddress || item.alarmName }}</span>
                    <span class="alarm-tag" :class="getAlarmTagClass(item)">{{ item.alarmDescription }}</span>
                  </div>
                  <div class="detail-body">
                    <div class="detail-row">
                      <span class="detail-label">开始报警时间:</span>
                      <span class="detail-value">{{ getStartAlarmTime(item) }}</span>
                    </div>
                    <div class="detail-row detail-row-wrap" v-if="item.alarmSource === 'dataInterruption'">
                      <span class="detail-label">报警说明:</span>
                      <span class="detail-value">{{ item.description != null && item.description !== '' ? item.description : '-' }}</span>
                    </div>
                    <template v-if="item.alarmSource === 'manual'">
                      <div class="detail-row">
                        <span class="detail-label">夜间总流量:</span>
                        <span class="detail-value">{{ item.refValue != null ? item.refValue : '-' }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">当前报警值:</span>
                        <span class="detail-value">{{ item.prewarningValue != null ? item.prewarningValue : '-' }}</span>
                      </div>
                    </template>
                    <template v-if="item.alarmSource === 'dualTrack'">
                      <div class="detail-row">
                        <span class="detail-label">最后报警时间:</span>
                        <span class="detail-value">{{ item.updateTime ||  '-' }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">夜间总流量:</span>
                        <span class="detail-value">{{ item.nightAllWaterNum != null ? item.nightAllWaterNum : (item.nightWaterNum != null ? item.nightWaterNum : '-') }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">夜间流量平均值:</span>
                        <span class="detail-value">{{ item.nightWaterNum != null ? item.nightWaterNum : (item.nightAvg != null ? item.nightAvg : '-') }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">正常范围:</span>
                        <span class="detail-value">{{ getNormalRange(item) }}</span>
                      </div>
                      <div class="detail-row">
                        <span class="detail-label">基线:</span>
                        <span class="detail-value">{{ item.baseLine != null ? item.baseLine : (item.baseline != null ? item.baseline : '-') }}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <div
                class="title"
                :class="getAlarmClass(item)"
                @click="Rowclicklu(item)"
              >
                <span class="alarmName">{{ item.alarmName }}</span>
                <span class="alarmTime">{{ item.alarmTime  }}</span>
                <span class="alarmDesc">{{ item.alarmDescription }}</span>
              </div>
            </a-popover>
          </div>
        </div>
        </template>
      </div>
    </div>
    <div v-if="!show" class="collapsed-btn" @click="show = true">
      <img src="@/assets/partition/alarmicon.svg" alt="" class="alert-icon" />
      <span class="btn-text">预警报警</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inputValue: Object
  },
  name: 'BulletinBoard',
  components: {},
  data() {
    return {
      dataList: [],
      speed: 100,
      colee: '',
      colee1: '',
      colee2: '',
      show: false,
      scrollTimer: null
    }
  },
  created() { },
  mounted() {
    this.getKanbanData()
  },
  methods: {
    getNormalRange(item) {
      if (item.floorWaterDistinction != null && item.upperWaterDistinction != null) {
        return `${item.floorWaterDistinction}~${item.upperWaterDistinction}`
      }
      return '-'
    },
    /** 详情「开始报警时间」：手动用 updateTime，双轨用 createTime，其余 createTime */
    getStartAlarmTime(item) {
      if (!item) return '-'
      if (item.alarmSource === 'manual') {
        const t = item.updateTime || item.collectTime || item.alarmTime
        return t != null && t !== '' ? t : '-'
      }
      if (item.alarmSource === 'dualTrack') {
        const t = item.createTime || item.collectTime || item.alarmTime
        return t != null && t !== '' ? t : '-'
      }
      const t = item.createTime
      return t != null && t !== '' ? t : '-'
    },

    getManualAlarmType(item) {
      return item.alarmContent || item.alarmLevel
    },
    getAlarmClass(item) {
      if (!item) return 'alarm-manual'
      if (this.containsPrewarning(item)) return 'alarm-prewarning'
      if (item.alarmSource === 'dataInterruption') return 'alarm-interruption'
      if (item.alarmSource === 'dualTrack') return 'alarm-dual-track'
      return 'alarm-manual'
    },
    containsPrewarning(item) {
      const titleText = `${item.alarmName || ''}${item.alarmDescription || ''}`
      return titleText.includes('预警')
    },
    getAlarmTagClass(item) {
      if (!item) return 'manual-tag'
      if (item.alarmSource === 'dataInterruption') return 'interruption-tag'
      if (item.alarmSource === 'dualTrack') return 'dual-track-tag'
      return 'manual-tag'
    },

    Rowclicklu(item) {
      if (item.alarmSource === 'dataInterruption') {
        // 数据中断报警
        this.$router.push({ path: '/zone-alarm-management/zone-interrupt-list' })
      } else if (item.alarmSource === 'manual') {
        // 手动设置报警
        this.$router.push({ path: '/zone-alarm-management/zone-alarm-list', query: { sysTab: '2' } })
      } else if (item.alarmSource === 'dualTrack') {
        // 双轨预警
        this.$router.push({ path: '/zone-alarm-management/zone-alarm-list', query: { sysTab: '6' } })
      }
    },
    /** 近 N 天 recent 接口：$http 已解包为 { code, data }，data 可为数组或 { list|data|records } */
    normalizeRecentAlarmList(body) {
      if (body == null) return []
      if (Array.isArray(body)) return body
      const payload = body.data
      if (payload == null) return []
      if (Array.isArray(payload)) return payload
      if (Array.isArray(payload.list)) return payload.list
      if (Array.isArray(payload.data)) return payload.data
      if (Array.isArray(payload.records)) return payload.records
      return []
    },
    getKanbanData() {
      Promise.all([
         this.$http.get('/smart-water-pipe-network/remote_water_meter_alarm_messages/recent/manual'),
         this.$http.get('/smart-water-pipe-network/remote_water_meter_alarm_messages/recent/dual-track'),
          this.$http.get('/smart-water-pipe-network/data_interruption_alarm_list/recent/unprocessed')
      ]).then(([ resManual, resDual, resInterrupt]) => {
        //resManual, resDual,
        const list2 = this.normalizeRecentAlarmList(resManual).map((item, idx) => ({
          ...item,
          id: item.id != null ? 'm-' + item.id : 'm-idx-' + idx,
          alarmSource: 'manual',
          alarmName: item.msgAddress || item.alarmName,
          alarmTime: item.updateTime || item.alarmTime || item.collectTime,
          alarmDescription: this.getManualAlarmType(item)
        }))

        const list3 = this.normalizeRecentAlarmList(resDual).map((item, idx) => ({
          ...item,
          id: item.id != null ? 'd-' + item.id : 'd-idx-' + idx,
          alarmSource: 'dualTrack',
          alarmName:  item.flowMeterName,
          alarmTime: item.createTime || item.alarmTime || item.collectTime,
          alarmDescription: item.alarmLevel
        }))

        const list1 = this.normalizeRecentAlarmList(resInterrupt).map((item, idx) => ({
          ...item,
          id: item.id != null ? item.id : 'di-idx-' + idx,
          alarmSource: 'dataInterruption',
          alarmTime: item.createTime,
          alarmName:item.deviceName,// item.alarmTypeName + item.alarmLevelName,
          alarmDescription:  item.alarmTypeName + item.alarmLevelName,
        }))



        const allList = [...list1, ...list2, ...list3]


        this.dataList = allList
        this.show = this.dataList.length > 0
        if (this.dataList.length > 2) {
          this.$nextTick(() => {
            this.goScroll()
          })
        }
      }).catch(() => {
        this.dataList = []
        this.show = false
      })
    },
    goScroll() {
      this.colee2 = document.getElementById('ulDiv2')
      this.colee1 = document.getElementById('ulDiv')
      this.colee = document.getElementById('dataWarp')
      this.scrollTimer = setInterval(this.Marquee1, this.speed)

      this.$once('hook:beforeDestroy', () => {
        this.pauseScroll()
      })
    },
    pauseScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    },
    resumeScroll() {
      if (!this.scrollTimer && this.colee) {
        this.scrollTimer = setInterval(this.Marquee1, this.speed)
      }
    },
    Marquee1() {
      // 当滚动至colee1与colee2交界时
      if (this.colee2.offsetTop - this.colee.scrollTop <= 0) {
        this.colee.scrollTop -= this.colee1.offsetHeight + 20 // colee跳到最顶端
      } else {
        this.colee.scrollTop++
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  position: absolute;
  top: 60px;
  left: 0;
  z-index: 99;

  .alarm-panel {
    position: relative;
    width: 380px;
    height: 236px;
    padding: 0;
    background: url('~@/assets/partition/alarmbox.svg') center center no-repeat;
    background-size: 100% 100%;
  }

  .panel-header {
    position: absolute;
    top: 28px;
    left: 27px;
    width: 326px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;

    .header-left {
      display: flex;
      align-items: center;

      .warning-icon {
        width: 14px;
        height: 14px;
        margin-right: 6px;
      }

      .header-title {
        font-size: 16px;
        // font-weight: bold;
        color: #fff;
        letter-spacing: 1px;
        text-shadow: 0 1px 2px rgba(0,0,0,0.3);
      }
    }

    .hide-btn {
      width: 20px;
      height: 20px;
      cursor: pointer;
      // opacity: 0.85;
      // transition: opacity 0.2s;

      // &:hover {
      //   opacity: 1;
      // }
    }
  }

  .dataWarp {
    position: absolute;
    top: 66px;
    left: 30px;
    width: 320px;
    height: 136px;
    overflow: hidden;
    padding: 4px 4px 6px;
    box-sizing: border-box;

    .empty-text {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: #ffffff;
      font-size: 15px;
      font-weight: 600;
      letter-spacing: 1px;
      border-radius: 6px;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
    }

    .dataItem {
      width: 100%;
      height: 30px;
      display: flex;
      align-items: center;
      box-sizing: border-box;

      /* a-popover 触发器外层多为 inline，不拉满会导致内部 grid 列宽抖动、对不齐 */
      > span {
        display: block;
        width: 100%;
        min-width: 0;
        height: 100%;
        box-sizing: border-box;
      }

      .title {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 132px 74px;
        column-gap: 4px;
        align-items: center;
        box-sizing: border-box;
        width: 100%;
        height: 26px;
        padding: 0 8px 0 4px;
        margin: 0;
        border-radius: 4px;
        cursor: pointer;
        color: #faad14;
        font-size: 13px;
        font-weight: 500;
        transition: background 0.2s, box-shadow 0.2s, color 0.2s;

        &:hover {
          background: #ffffff;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
          z-index: 1;
        }

        &.alarm-manual {
          color: #e53935;
        }
        &.alarm-prewarning {
          color: #faad14;
        }
        &.alarm-interruption {
          color: #fa8c16;
        }
        &.alarm-dual-track {
          color: #e53935;
        }

        .alarmName,
        .alarmTime,
        .alarmDesc {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .alarmName {
          min-width: 0;
          padding-left: 0;
          text-align: left;
        }

        .alarmTime {
          font-size: 12px;
          letter-spacing: -0.2px;
          text-align: left;
        }

        .alarmDesc {
          font-size: 12px;
          min-width: 0;
          text-align: right;
        }
      }
    }
  }

  .collapsed-btn {
    position: absolute;
    left: 0;
    top: 0;
    width: 30px;
    padding: 10px 0;
    background: #ffffff;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.12);
    border-radius: 0 4px 4px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      box-shadow: 2px 0 12px rgba(0, 0, 0, 0.2);
      background: #fdfdfd;
    }

    .alert-icon {
      width: 18px;
      height: 18px;
      margin-bottom: 6px;
      animation: alert-icon-blink 1.2s ease-in-out infinite;
    }

    .btn-text {
      width: 14px;
      font-size: 14px;
      line-height: 1.2;
      color: #8c8c8c;
      text-align: center;
      word-wrap: break-word;
      letter-spacing: 2px;
    }
  }
}

@keyframes alert-icon-blink {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
    filter: drop-shadow(0 0 0 rgba(244, 234, 42, 0));
  }
  50% {
    opacity: 0.45;
    transform: scale(1.08);
    filter: drop-shadow(0 0 6px rgba(244, 234, 42, 0.9));
  }
}

.alarm-detail-popover {
  min-width: 280px;
  max-width: 380px;
  padding: 4px 0;

  .detail-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 10px;

    .zone-name {
      font-size: 15px;
      font-weight: bold;
      color: #f5222d;
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .alarm-tag {
      font-size: 12px;
      color: #f5222d;
      background: #fff1f0;
      border: 1px solid #ffa39e;
      padding: 2px 8px;
      border-radius: 10px;
      margin-left: 10px;
      white-space: nowrap;
      flex-shrink: 0;
      line-height: 1.4;
    }

    .manual-tag {
      color: #f5222d;
      background: #fff1f0;
      border-color: #ffa39e;
    }

    .interruption-tag {
      color: #d46b08;
      background: #fff7e6;
      border-color: #ffd591;
    }

    .dual-track-tag {
      color: #fa541c;
      background: #fff2e8;
      border-color: #ffbb96;
    }
  }

  .detail-body {
    .detail-row {
      display: grid;
      grid-template-columns: 110px minmax(0, 1fr);
      column-gap: 10px;
      align-items: start;
      font-size: 13px;
      line-height: 1.8;
      margin-bottom: 6px;

      .detail-label {
        color: #666;
        margin-right: 0;
        width: auto;
        text-align: right;
        white-space: nowrap;
      }

      .detail-value {
        color: #1f1f1f;
        min-width: 0;
        margin-left: 0;
        text-align: left;
        word-break: break-word;
      }

      &.detail-row-wrap {
        align-items: start;

        .detail-value {
          white-space: pre-wrap;
          overflow-wrap: break-word;
        }
      }
    }
  }
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
